import { Notificacion } from '@components/general/Alertas/Alertas';
import { solicitarCancelacionKueski } from '@helpers/httpRequests/httpRequestKueski/httpRequesKueski';
import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'

const CancelarOrdenKueski = ({payment_id, setOrdenCancelada}) => {

  console.log(payment_id);

  const cancelar = () => {
    Notificacion("info", "No se realizó la cancelación")
  }

  const handleCancelacion = async() => {
    try{
     await solicitarCancelacionKueski({payment_id});

     setOrdenCancelada(true);
     Notificacion("success", "Orden cancelada");

    }catch(error){
      console.log(error);
      console.log("Error al solicitar la cancelación de la orden.")
     Notificacion("error", "No se pudo cancelar la orden");

    }
  }

  return (
    <Container>
        <Row>
            <Col className="col-12">

                <h2>¿Estás seguro de cancelar la orden?</h2>
                <small>Se solicitará la cancelación de la orden a Kueski inmediatamente.</small>
            </Col>

            <Col className="d-flex flex-row justify-content-around mt-4">
              <Button className="btn btn-danger" onClick={cancelar}>Cancelar</Button>
              <Button className="btn btn-success" onClick={handleCancelacion}>Solicitar cancelación</Button>
            </Col>
        </Row>
    </Container>
  )
}

export default CancelarOrdenKueski